<template>
  <div class="jobs-register-panels">
    <div v-if="!isLoggedIn">
      <jobs-find-a-job-through-register
        @on-find-job-click="goToRegister">
      </jobs-find-a-job-through-register>
      <jobs-referral-link-container></jobs-referral-link-container>
    </div>
    <referral-link-container v-else-if="profileDetailsState && profileDetailsState.referral_code"></referral-link-container>
  </div>
</template>

<script>
import redirects from 'top20common/distribution/services/redirects';

import {b2c} from 'top20common/distribution/constants/scopes';
import {mapGetters} from 'vuex';

import ReferralLinkContainer from '@/common/referral-link/ReferralLinkContainer';

import JobsFindAJobThroughRegister from './JobsFindAJobThroughRegister';
import JobsReferralLinkContainer from './JobsReferralLinkContainer';

export default {
  created() {
    if (this.isLoggedIn) {
      this.$store.dispatch('getProfileAction');
      this.$store.dispatch('fetchTokensAction');
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'tokensMetaState', 'profileDetailsState']),
    isCandidate() {
      return this.$store.getters.userScopesState.includes(b2c);
    }
  },
  methods: {
    goToRegister() {
      let queryParams = '';
      if (this.$route.query.source) {
        queryParams = `source=${this.$route.query.source}`;
      }

      redirects.goToCandidateRegister(null, null, null, queryParams);
    }
  },
  components: {
    JobsFindAJobThroughRegister,
    JobsReferralLinkContainer,
    ReferralLinkContainer
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

@media (min-width: $tablet) {
  .jobs-register-panels {
    /deep/ .jobs-find-a-job {
      margin-bottom: 40px;
    }
  }
}

@media (max-width: $widescreen) {
  .jobs-register-panels {
    /deep/ .jobs-find-a-job {
      width: 100vw;
      position: relative;
      left: 50%;
      right: 50%;
      margin: 0 -50vw 40px;
    }
  }
}
</style>
